module.exports = __webpack_public_path__ + "static/media/muscular.03b4d988.png";